import { z } from "zod";
import { dmaUserSchema } from "../dma-user";
import { dmaMicelleCompoundDtoSchema } from "./dma-micelle-compound.schema";
export const dmaMicelleDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    composition: z.array(dmaMicelleCompoundDtoSchema),
    tags: z.array(z.string()),
    updatedAt: z.string().datetime(),
    updatedBy: z.nullable(dmaUserSchema),
});
